export default "__VITE_ASSET__CJFYPCRR__"